__turbopack_context__.v({
  "button": "AIInsights-module-scss-module___bLs1a__button",
  "card": "AIInsights-module-scss-module___bLs1a__card",
  "component": "AIInsights-module-scss-module___bLs1a__component",
  "content": "AIInsights-module-scss-module___bLs1a__content",
  "emptyIcon": "AIInsights-module-scss-module___bLs1a__emptyIcon",
  "emptyState": "AIInsights-module-scss-module___bLs1a__emptyState",
  "emptyText": "AIInsights-module-scss-module___bLs1a__emptyText",
  "header": "AIInsights-module-scss-module___bLs1a__header",
  "icon": "AIInsights-module-scss-module___bLs1a__icon",
  "insightItem": "AIInsights-module-scss-module___bLs1a__insightItem",
  "insightText": "AIInsights-module-scss-module___bLs1a__insightText",
  "insightsList": "AIInsights-module-scss-module___bLs1a__insightsList",
  "refreshButton": "AIInsights-module-scss-module___bLs1a__refreshButton",
  "refreshIcon": "AIInsights-module-scss-module___bLs1a__refreshIcon",
  "title": "AIInsights-module-scss-module___bLs1a__title",
});
